module.exports = __webpack_public_path__ + "media/images/application/template/boxplus/map-marker-7df190c484751e70c35fd78cb0a7db45.png";